<template>
  <div class="row">
    <BaseTextInput
      v-bind="logradouro"
      v-bind:disabled="readonly"
      v-bind:value="value.logradouro"
    />
    <BaseTextInput
      v-bind="numero"
      v-bind:disabled="readonly"
      v-bind:value="value.numero"
    />
    <BaseTextInput
      v-bind="complemento"
      v-bind:disabled="readonly"
      v-bind:value="value.complemento"
    />
    <BaseTextInput
      v-bind="cep"
      v-bind:disabled="readonly"
      v-bind:value="value.cep"
    />
    <BaseTextInput
      v-bind="bairro"
      v-bind:disabled="readonly"
      v-bind:value="value.bairro"
    />
    <BaseTextInput
      v-bind="uf"
      v-bind:disabled="readonly"
      v-bind:value="formattedUF"
    />
    <BaseTextInput
      v-bind="nomeMunicipio"
      v-bind:disabled="readonly"
      v-bind:value="formattedMunicipio"
    />
    <BaseTextInput
      v-bind="tipo"
      v-bind:disabled="readonly"
      v-bind:value="value.tipoEndereco"
    />
  </div>
</template>

<script>
import { API_URL } from "../../constants";

export default {
  name: "BaseEndereco",
  inheritAttrs: false,
  props: {
    logradouro: {
      type: Object,
      required: true
    },
    numero: {
      type: Object,
      required: true
    },
    complemento: {
      type: Object,
      required: true
    },
    bairro: {
      type: Object,
      required: true
    },
    cep: {
      type: Object,
      required: true
    },
    nomeMunicipio: {
      type: Object,
      required: true
    },
    uf: {
      type: Object,
      required: true
    },
    tipo: {
      type: Object,
      required: true
    },
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      readonly: true,
      municipio: null
    };
  },
  computed: {
    formattedMunicipio() {
      return (this.municipio || {}).nome;
    },
    formattedUF() {
      return (this.municipio || {}).uf;
    }
  },
  watch: {
    "value.municipioId": {
      immediate: true,

      handler(newMunicipioId) {
        if (newMunicipioId) {
          this.$http
            .get(`${API_URL}/core/municipio/${newMunicipioId}`)
            .then(response => (this.municipio = response.data))
            .catch(error =>
              this.$notification.pushError(
                `Houve um erro ao obter os dados do município: ${error.message}`
              )
            );
        } else {
          this.municipio = null;
        }
      }
    }
  }
};
</script>

<style scoped>
.row {
  margin-bottom: 0;
}
</style>
